import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

function Avatar({ username, size = 72 }) {
  const letters = username
    ? username.split(/[\s_-]/).map(p => p[0]).slice(0, 2).join("").toUpperCase()
    : "?";
  const hue = username
    ? (username.charCodeAt(0) * 17 + (username.charCodeAt(1) || 0) * 7) % 360
    : 200;
  return (
    <div style={{
      width: size, height: size, borderRadius: "50%",
      background: `hsl(${hue},40%,16%)`,
      color: `hsl(${hue},65%,62%)`,
      border: `2px solid hsl(${hue},40%,26%)`,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontSize: size * 0.38, fontWeight: 800,
      fontFamily: "'Bricolage Grotesque', sans-serif",
    }}>{letters}</div>
  );
}

export default function ProfilePage() {
  const navigate = useNavigate();
  const { currentUser, logout } = useAuth();

  function handleLogout() {
    logout();
    navigate("/");
  }

  if (!currentUser) {
    navigate("/auth");
    return null;
  }

  const joinDate = currentUser.created_at
    ? new Date(currentUser.created_at).toLocaleDateString("en-US", { year: "numeric", month: "long" })
    : null;

  return (
    <div style={{ minHeight: "100vh", background: "#0b0b0c" }}>
      <div style={{ maxWidth: 640, margin: "0 auto", padding: "48px 20px" }}>

        {/* Back */}
        <button
          onClick={() => navigate(-1)}
          style={{ background: "none", border: "none", color: "#55555e", cursor: "pointer", fontSize: 13, marginBottom: 32, fontFamily: "'Plus Jakarta Sans', sans-serif" }}
        >← back</button>

        {/* Avatar + name */}
        <div style={{ display: "flex", alignItems: "center", gap: 20, marginBottom: 36 }}>
          <Avatar username={currentUser.username} size={72} />
          <div>
            <div style={{ fontFamily: "'Bricolage Grotesque', sans-serif", fontSize: 24, fontWeight: 800, color: "#f0f0f0", marginBottom: 4 }}>
              {currentUser.username}
            </div>
            {joinDate && (
              <div style={{ fontSize: 12, color: "#55555e", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                member since {joinDate}
              </div>
            )}
          </div>
        </div>

        {/* Details card */}
        <div style={{ background: "#111113", border: "0.5px solid #252528", borderRadius: 14, padding: 20, marginBottom: 16 }}>
          <div style={{ fontSize: 10, color: "#55555e", textTransform: "uppercase", letterSpacing: "0.8px", marginBottom: 14, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
            account info
          </div>
          {[
            ["username",  currentUser.username],
            ["email",     currentUser.email],
            ["phone",     currentUser.phone],
            ["location",  currentUser.location],
          ].filter(([, v]) => v).map(([label, value]) => (
            <div key={label} style={{ display: "flex", justifyContent: "space-between", fontSize: 13, padding: "9px 0", borderBottom: "0.5px solid #1c1c1f" }}>
              <span style={{ color: "#55555e", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{label}</span>
              <span style={{ color: "#c0c0c0", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{value}</span>
            </div>
          ))}
        </div>

        {/* Quick links */}
        <div style={{ background: "#111113", border: "0.5px solid #252528", borderRadius: 14, padding: 20, marginBottom: 16 }}>
          {[
            { icon: "📋", label: "My Lists",    onClick: () => navigate("/lists") },
            { icon: "💬", label: "Discussions", onClick: () => navigate("/discussions") },
            { icon: "⚙️", label: "Settings",    onClick: () => navigate("/settings") },
          ].map(({ icon, label, onClick }) => (
            <div key={label} onClick={onClick} style={{ display: "flex", alignItems: "center", gap: 12, padding: "11px 0", cursor: "pointer", borderBottom: "0.5px solid #1c1c1f" }}
              onMouseEnter={e => e.currentTarget.style.opacity = "0.75"}
              onMouseLeave={e => e.currentTarget.style.opacity = "1"}
            >
              <span style={{ fontSize: 16 }}>{icon}</span>
              <span style={{ fontSize: 13, color: "#c0c0c0", fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{label}</span>
              <span style={{ marginLeft: "auto", color: "#3a3a44", fontSize: 14 }}>›</span>
            </div>
          ))}
        </div>

        <button
          onClick={handleLogout}
          style={{
            width: "100%", padding: "12px", borderRadius: 12,
            background: "transparent", border: "0.5px solid #3a1a1a",
            color: "#9a4a4a", fontSize: 13, fontWeight: 600,
            fontFamily: "'Plus Jakarta Sans', sans-serif", cursor: "pointer",
            transition: "background 0.15s",
          }}
          onMouseEnter={e => e.currentTarget.style.background = "#1a1010"}
          onMouseLeave={e => e.currentTarget.style.background = "transparent"}
        >
          sign out
        </button>
      </div>
    </div>
  );
}
